import { Button, Card } from "@/src/components";
import { useStake } from "@/src/hooks/useStake";
import { ReloadIcon } from "@/src/icons";
import { useRebase } from "@/src/context";
import { toast } from "react-hot-toast";
import { useAccount } from "wagmi";
import { useState, useEffect } from "react";
import { useBalances } from "@/src/hooks/useBalances";
import { activeChain } from "@/src/configs/chainConfig";

export const HarvestButton = () => {
  const { chain } = useAccount();
  const [rebaseInterval, setRebaseInterval] = useState(0);
  const [lastRebaseTime, setLastRebaseTime] = useState(0);
  const [, setRebaseRate] = useState(0);
  const {stakeBalance, unCharged, pendingRewards, frbBalance} = useBalances();
  const [timeCheck, setTime] = useState(0);
  const{timeCheck: timeCheckProp} = useState(new Date());
  const { rebaseInterval: rebaseIntervalProp, lastRebaseTime: lastRebaseTimeProp, rebaseRate: rebaseRateProp} = useRebase();
  useEffect(() => {
    setRebaseInterval(parseInt(rebaseIntervalProp));
    setLastRebaseTime(parseInt(lastRebaseTimeProp));
    setRebaseRate(parseFloat(rebaseRateProp));
    setTime(timeCheckProp);
  }, [rebaseIntervalProp, lastRebaseTimeProp, rebaseRateProp, timeCheckProp]);
  const { isConnected } = useAccount();
  const { onHarvest, onChargeReborn, onChargePendingRewards } = useStake();
  const [isValid, setValid] = useState(false);

  const [{ isCorrectChain }, setState] = useState({
    isCorrectChain: true,
  });

  useEffect(() => {
    if (isConnected)
      setState({
        isCorrectChain: chain?.id === Number(activeChain.chainId),
      });

  }, [chain, isConnected]);

  const validate = () => {
    if (stakeBalance === 0){
      return false;
    }
    if (!isCorrectChain){
      return false;
    }
    if(lastRebaseTime > 0){
      return Date.now()/1000 > (lastRebaseTime + rebaseInterval);

    }else{return true;}
  };
  useEffect(() => {
    const isValid = validate();
    setValid(isValid);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lastRebaseTime, rebaseInterval, timeCheck]);

  useEffect(() => {
    const interval = setInterval(() => {
      setTime(new Date());
    }, 2000);
    return () => clearInterval(interval);
  }, []);

  const handleRebase = async () => {
    if (!isConnected) return;

    await toast.promise(onHarvest(), {
      loading: "Transaction is in progress",
      success: "Successfully harvested FRB",
      error: (data) => data,
    }
    );
    await new Promise(resolve => setTimeout(resolve, 2000));
    window.location.reload(false);
  };
  const handleCharge = async (event) => {
    event.preventDefault();
    if (!isConnected) return;
    if ((parseFloat(unCharged)*30) <= parseFloat(pendingRewards)){
      await toast.promise(onChargePendingRewards(unCharged), {
        loading: "Transaction is in progress",
        success: "Successfully charged Flare Reborn NFTs",
        error: (data) => data,
      })}else {
        if ((parseFloat(unCharged)*30) <= parseFloat(frbBalance) && unCharged > 0)
          await toast.promise(onChargeReborn(unCharged), {
            loading: "Transaction is in progress",
            success: "Successfully charged Flare Reborn NFTs",
            error: (data) => data,
        });
      }
      await toast.promise(onHarvest(), {
        loading: "Transaction is in progress",
        success: "Successfully harvested FRB",
        error: (data) => data,
      }
      );
      await new Promise(resolve => setTimeout(resolve, 2000));
      window.location.reload(false);
  };

  return (
    <Card>
      <div className="space-y-4">
        <h2 className="text-sm font-medium text-muted-foreground uppercase tracking-wider">
          Harvest
        </h2>

        <div className="space-y-3">
          <Button onClick={handleRebase} disabled={!isValid} className="gap-2.5">
            <ReloadIcon className="h-4 w-4" />
            Harvest
          </Button>

          {Date.now()/1000 > (lastRebaseTime + rebaseInterval) && unCharged > 0 && ((parseFloat(unCharged)*30) <= parseFloat(pendingRewards) || ((parseFloat(unCharged)*30) <= parseFloat(frbBalance))) &&
            <Button onClick={handleCharge} disabled={!isValid} variant="secondary" className="gap-2.5">
              <ReloadIcon className="h-4 w-4" />
              Charge & Harvest
            </Button>
          }
        </div>
      </div>
    </Card>
  );
};
